import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AppConfigService } from 'src/app/core/services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class VipRouteGuard implements CanActivate {

  constructor(
    private router: Router,
    private appConfig: AppConfigService
  ) { }

  private readonly allowedRoutes: string[] = [
    '/dashboard',
    '/pos/pos',
    '/pos/list-sales'
  ];

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    // si VIP mode no está activo no bloquea nada
    if (!this.appConfig.isVipMode) {
      return true;
    }

    const currentUrl = state.url.split('?')[0];

    const allowed = this.allowedRoutes.some(r => currentUrl.startsWith(r));

    if (!allowed) {
      this.router.navigate(['/dashboard']);
      return false;
    }

    return true;
  }
}
